import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useFormik } from 'formik';
import { loginSchema } from '../schemas';
import { FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import { postLogin } from '../apiservices/ApiServices';
import Loader from '../components/Loader/Loader';
import logo from '../assets/images/logo.png';

const initialValues = {
    email: 'admin@kga.com',
    password: 'Admin@123',
}

const Login = () => {
    const [isLoading, setLoading] = useState(false);
    const [isViewPass, setIsViewPass] = useState(false);

    const Logins = async (values) => {
        setLoading(true);
        let postdata =
        {
            email: values.email,
            password: values.password,
        }
        try {
            const res = await postLogin(postdata);

            localStorage.setItem('useToken', res.data.data.token);
            localStorage.setItem('userData', JSON.stringify(res.data.data.user));
            localStorage.setItem('defaultProfile', JSON.stringify(res.data.data?.profile));
            localStorage.setItem('profileId', res.data.data?.profile?.profile_id);

            toast.success(res.data.message);
            setLoading(false);
            setTimeout(() => window.location.reload(), 3000);

        } catch (error) {
            setLoading(false);
            toast.error(error.response.data.message);
        }
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: loginSchema,
        onSubmit: (values) => {
            Logins(values);
        }
    })

    return (
        <div className='login-img'>
            <div className='page'>
                <ToastContainer
                    position="top-right"
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ zIndex: 9999999999, position: 'fixed' }}
                />
                <div className='col-login mx-auto mt-7'></div>
                <div className='container-login100'>
                    <div className='wrap-login100 p-6 loginboxs'>
                        <div className='logobox'>
                            <img src={logo} alt='Logo' title='Logo' />
                        </div>
                        <div className="titles">
                            <h2>Sign In</h2>
                            <p>Welcome back to your account.</p>
                        </div>
                        <form onSubmit={handleSubmit} className='login100-form validate-form' autoComplete="off">
                            <div className='form-group'>
                                <div className="control has-icon">
                                    <label className="label auth-label" htmlFor="v-field-1">Email Address</label>
                                    <input type="email"
                                        id="email"
                                        name="email"
                                        className="input v-input"
                                        autoComplete='off'
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.email && touched.email ? (
                                        <p className='errormsg'>{errors.email}</p>
                                    ) : null}
                                    <label className="label form-icon" htmlFor="v-field-1">
                                        <FaEnvelope />
                                    </label>
                                </div>
                            </div>
                            <div className='form-group io'>
                                <div className="control has-icon">
                                    <label className="label auth-label" htmlFor="v-field-2">Password</label>
                                    <input
                                        type={isViewPass ? 'text' : 'password'}
                                        id="password"
                                        name="password"
                                        className="input v-input"
                                        autoComplete='off'
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.password && touched.password ? (
                                        <p className='errormsg'>{errors.password}</p>
                                    ) : null}
                                    <label className="label form-icon" htmlFor="v-field-1">
                                        {isViewPass ?
                                            <FaEyeSlash onClick={() => setIsViewPass(false)} /> :
                                            <FaEye onClick={() => setIsViewPass(true)} />
                                        }
                                    </label>
                                </div>
                            </div>
                            <div className='buttonbox'>
                                <button type='submit' className='btn btn-primary'>Login</button>
                                <Link className='links' to={'/forgot-password'}>Forgot Password?</Link>
                            </div>
                        </form>
                    </div>
                </div>
                {isLoading ? (
                    <Loader />
                ) : null}
            </div>
        </div>
    );
}

export default Login